/** @module FormulatedProduct/WhereUsedTable */
define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare, TableWidget) {

	const OMIT_DATA_SHEET_TYPES = new Set([
		"ApparelBOM",
		"Artwork",
		"CareAndComposition",
		"CollectionColor",
		"CollectionMatrix",
		"CollectionMaterial",
		"ColorDataSheet",
		"DataSheetSizeLabel",
		"ImageDataSheet",
		"MaterialBOM",
		"MaterialDataSheet",
		"MaterialSchedule",
		"PriceList",
		"PrintDesign",
		"ProductBOM",
		"PropertiesDataSheet",
		"Review",
		"ReviewCollection",
		"ReviewColorway",
		"ReviewFood",
		"ReviewFoodSKU",
		"ReviewSKU",
		"ReviewStyle",
		"Routing",
		"SizeChartReview",
		"SizeChart",
		"SpecificationDataSheet",
		"SubRouting",
		"TestRun",
	]);

	const OMIT_DATA_SHEET_TYPES_FOR_FORMULATED_MATERIAL = new Set([
		"FoodBOM",
	]);


	return declare(TableWidget, {
		/**
		 * @override
		 * Disable node properties for change log
		 */
		onCustomViewAttributeOptions(options) {
			const {defView} = this;

			options.omitContainerCallback = ({endClass, endType}) => {
				const type = endClass.getMasterClass()?.type || endType;

				return OMIT_DATA_SHEET_TYPES.has(type) ||
					(OMIT_DATA_SHEET_TYPES_FOR_FORMULATED_MATERIAL.has(type) && (defView.m_id === "WhereUsedFormulatedMaterial"));
			};

			this.inherited(arguments);
		},
	});
});